import * as types from "../types";

const accountState = {
    displayPopover: false,
    resetPosition: 1,
    date_od: "",
    date_do: "",
    operator: "",
    potwierdzony: '',
    klient: "",
    anchorEl: null
}

export default function (state = accountState, action) {
    switch (action.type) {
        case types.SET_POPOUT_DATA: {
            return {
                ...state,
                ...action.value
            }
        }
    }

    return state;
}